clearProps